import React from 'react'
import Suporte from '../components/organisms/Suporte'

function SuportePage({ location }) {
  const { state } = location

  return <Suporte {...state} />
}

export default SuportePage 